
// 1.

// import React, { useState, useEffect, useRef } from "react";
// import { TbRefresh } from "react-icons/tb";
// import axios from "axios";
// import { BaseUrl } from "../../../../../../api/AxiosApi";
// import { Line } from "react-chartjs-2";
// import {
//     Chart as ChartJS,
//     CategoryScale,
//     LinearScale,
//     PointElement,
//     LineElement,
//     Title,
//     Tooltip,
//     Legend,
// } from "chart.js";
// import DownloadJpegButton from "../../../../../../components/downloadJpegButton/DownloadJpegButton";
// import UserAnalyticsTableTab1 from "./UserAnalyticsTableTab1";

// ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

// export function getDateTimeForDashboardTab1(date = new Date()) {
//     const formattedCurrentDate = date.toISOString().split("T")[0];
//     const oneWeekAgo = new Date(date);
//     oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
//     const formattedOneWeekAgo = oneWeekAgo.toISOString().split("T")[0];
//     return {
//         Today: formattedCurrentDate,
//         LastWeek: formattedOneWeekAgo,
//     };
// }


// function UserAnalyticsTab1() {
// const chartRef = useRef();
//     const [selectedUser, setSelectedUser] = useState(null);
//     const [inverters, setInverters] = useState([]);
//     const [compareInverters, setCompareInverters] = useState([]);
//     const [chartData, setChartData] = useState(null);
//     const [fromDate, setFromDate] = useState(getDateTimeForDashboardTab1().LastWeek);
//     const [toDate, setToDate] = useState(getDateTimeForDashboardTab1().Today);
//     const [metric, setMetric] = useState("ENG");
//     const [loading, setLoading] = useState(false);



//     // ✅ Fetch Inverters for Selected User
//     // Make credentials global or at the component level
//     const credentials = {
//         LOGIN_ID: sessionStorage.getItem("LoginID"),
//         LOC_CODE: sessionStorage.getItem("LCODE"),
//         PASS_KEY: 'XYZ',
//         WEB_KEY: "WEBXYZ321",
//         TYP: "I",
//     };

//     const fetchInverters = async () => {
//         try {
//             console.log("Axios GET params:", credentials); // Console log the credentials here
//             const res = await axios.get(`${BaseUrl}CMN_07_Super/GET_FEEDER_LIST`, { params: credentials });
//             setInverters(res.data.FEED || []);
//             setChartData(null);
//         } catch (err) {
//             console.error("Inverter API Error:", err);
//         }
//     };



//     const handleUserSelect = (user) => {
//         setSelectedUser(user);
//         fetchInverters(user);
//     };

//     const toggleCompareInverter = (inv) => {
//         setCompareInverters((prev) =>
//             prev.some((c) => c.feeder_id === inv.feeder_id)
//                 ? prev.filter((c) => c.feeder_id !== inv.feeder_id)
//                 : [...prev, inv]
//         );
//     };

//     // ✅ Fetch Performance Data
//     const fetchChartData = async () => {
//         if (compareInverters.length === 0) {
//             alert("Please select a user and at least one inverter!");
//             return;
//         }

//         setLoading(true);
//         try {
//             let datasets = [];
//             let labels = [];

//             for (let i = 0; i < compareInverters.length; i++) {
//                 const inv = compareInverters[i];
//                 const res = await axios.get(`${BaseUrl}CMN_08InvLog/Get_Inv_Perf`, {
//                     params: {
//                         LOGIN_ID: sessionStorage.getItem("LoginID"),
//                         LOC_CODE: sessionStorage.getItem("LCODE"),
//                         PASS_KEY: 'XYZ',
//                         WEB_KEY: "WEBXYZ321",
//                         MTR_NO: inv.feeder_id,
//                         DT1: fromDate,
//                         DT2: toDate,
//                     },
//                 });

//                 const apiData = res.data.data || [];
//                 if (apiData.length === 0) continue;

//                 const invLabels = apiData.map((d) => d.DATET || d.date || "");
//                 const values = apiData.map((d) => parseFloat(d[metric] ?? 0));
//                 if (i === 0) labels = invLabels;

//                 datasets.push({
//                     label: `${inv.name}`,
//                     data: values,
//                     borderColor: "#" + Math.floor(Math.random() * 16777215).toString(16),
//                     fill: false,
//                     tension: 0.3,
//                 });
//             }

//             if (datasets.length === 0) {
//                 alert("No data available for selected inverters and dates!");
//                 setChartData(null);
//             } else {
//                 setChartData({ labels, datasets });
//             }
//         } catch (err) {
//             console.error("Chart API Error:", err);
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchInverters();
//     }, []);

//     return (
//         <>
// <div style={{ padding: "10px" }}>
//             <div
//                 style={{
//                     borderTop: "1px solid #ccc",
//                     borderRadius: "6px",
//                     padding: "8px",
//                     backgroundColor: "white",
//                     boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
//                 }}
//             >
//                 <h5 style={{ margin: 0 }}>Analytics</h5>
//             </div>

//             {/* USER - INVERTER - COMPARE */}
//             <div style={{ display: "flex", gap: "6px", flexWrap: "wrap", marginTop: 10 }}>
//                 {/* User List */}


//                 {/* Inverters */}
//                 <div style={panelStyle}>
//                     <h6>Inverters</h6>
//                     <ul style={listStyle}>
//                         {inverters.map((inv) => (
//                             <li key={inv.feeder_id} style={listItem}>
//                                 <input
//                                     type="checkbox"
//                                     checked={compareInverters.some((c) => c.feeder_id === inv.feeder_id)}
//                                     onChange={() => toggleCompareInverter(inv)}
//                                 />
//                                 <span style={nameStyle}>{inv.name}</span>
//                                 <span style={capStyle}>[{inv.kwp}kWp]</span>
//                             </li>
//                         ))}
//                     </ul>
//                 </div>

//                 {/* Compare Inverters */}
//                 <div style={panelStyle}>
//                     <h6>Compare Inverters</h6>
//                     <ul style={listStyle}>
//                         {compareInverters.map((c) => (
//                             <li key={c.feeder_id} style={listItem}>
//                                 <span style={nameStyle}>{c.name}</span>
//                                 <span style={capStyle}>{c.kwp}kWp</span>
//                                 <button style={removeBtn} onClick={() => toggleCompareInverter(c)}>
//                                     Remove
//                                 </button>
//                             </li>
//                         ))}
//                     </ul>
//                 </div>
//             </div>

//             {/* Filters */}
//             <div style={filterStyle}>
//                 <label style={labelStyle}>Select Type:</label>
//                 <select value={metric} onChange={(e) => setMetric(e.target.value)} style={selectStyle}>
//                     <option value="ENG">Energy Generation</option>
//                     <option value="CUF">CUF</option>
//                     <option value="Specific_Yield">Specific Yield</option>
//                     <option value="Specific_Power">Specific Power</option>
//                     <option value="KW_MAX">Peak Generation</option>
//                     <option value="PR">PR</option>
//                 </select>

//                 <label style={labelStyle}>From:</label>
//                 <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} style={inputStyle} />

//                 <label style={labelStyle}>To:</label>
//                 <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} style={inputStyle} />

//                 <TbRefresh
//                     style={{ fontSize: "1.5rem", cursor: "pointer" }}
//                     onClick={fetchChartData}
//                     title="Refresh Chart"
//                 />

// <DownloadJpegButton targetRef={chartRef} fileName={`General Comparison.jpeg`} />
//             </div>

//             {/* Chart */}
//             {chartData && (
//                 <div
//                     style={{
//                         marginTop: 12,
//                         backgroundColor: "white",
//                         borderRadius: 8,
//                         padding: 10,
//                         height: 300,
//                         width: "100%",
//                         boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
//                     }}
//                     ref={chartRef} 
//                 >
//                     <Line
//                         data={chartData}
//                         options={{
//                             responsive: true,
//                             maintainAspectRatio: false,
//                             plugins: {
//                                 legend: { position: "top", labels: { font: { size: 12 } } },
//                                 // title: { display: true, text: `Inverter Performance (${metric})`, font: { size: 14 } },
//                             },
//                             scales: {
//                                 x: { ticks: { font: { size: 11 } } },
//                                 y: { ticks: { font: { size: 11 } } },
//                             },
//                         }}
//                     />
//                 </div>
//             )}
//         </div>

//         <UserAnalyticsTableTab1/>        
//         </>
//     );
// }

// /* ---------- Inline Style Objects ---------- */
// const panelStyle = {
//     flex: 1,
//     minWidth: 200,
//     border: "1px solid #ccc",
//     borderRadius: 6,
//     padding: 10,
//     maxHeight: 170,
//     overflowY: "auto",
//     backgroundColor: "white",
//     boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
// };

// const listStyle = { listStyle: "none", padding: 0, margin: 0 };
// const listItem = { display: "flex", alignItems: "center", gap: 6, marginBottom: 6 };
// const nameStyle = { fontSize: 13 };
// const capStyle = { color: "#888", fontSize: 12 };
// const removeBtn = {
//     marginLeft: "auto",
//     background: "#ff5252",
//     color: "white",
//     border: "none",
//     padding: "2px 6px",
//     borderRadius: 4,
//     cursor: "pointer",
//     fontSize: 11,
// };

// const filterStyle = {
//     marginTop: 10,
//     display: "flex",
//     alignItems: "center",
//     gap: 10,
//     flexWrap: "wrap",
//     backgroundColor: "#f9f9f9",
//     padding: 10,
//     borderRadius: 6,
//     boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
// };

// const labelStyle = { fontSize: 14, fontWeight: 500 };
// const inputStyle = {
//     fontSize: 14,
//     borderRadius: 6,
//     border: "1px solid #ccc",
//     padding: "4px 10px",
//     height: 32,
// };
// const selectStyle = {
//     fontSize: 14,
//     borderRadius: 6,
//     border: "1px solid #ccc",
//     padding: "4px 10px",
//     height: 32,
//     backgroundColor: "white",
// };

// export default UserAnalyticsTab1;





import React, { useState, useEffect, useRef, useContext } from "react";
import { TbRefresh } from "react-icons/tb";
import axios from "axios";
import { BaseUrl } from "../../../../../../api/AxiosApi";
import { Line } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import DownloadJpegButton from "../../../../../../components/downloadJpegButton/DownloadJpegButton";
import ExportExcel from "../../../../../../components/exportExcel/ExportExcel1";
import { AuthenticationContext } from "../../../../../../context/AuthenticationContext";

// यदि AuthenticationContext का उपयोग करना है, तो इसे अनकमेंट करें
// import { AuthenticationContext } from "../../../../../../context/AuthenticationContext"; 

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

// 📅 तारीख जनरेट करने का हेल्पर फंक्शन
export function getDateTimeForDashboardTab1(date = new Date()) {
    const formattedCurrentDate = date.toISOString().split("T")[0];
    const oneWeekAgo = new Date(date);
    oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
    const formattedOneWeekAgo = oneWeekAgo.toISOString().split("T")[0];
    return {
        Today: formattedCurrentDate,
        LastWeek: formattedOneWeekAgo,
    };
}

function UserAnalyticsTab1() {
    // यदि कॉन्टेक्स्ट का उपयोग कर रहे हैं:
    const { LoggedInUserInfo } = React.useContext(AuthenticationContext)


    const chartRef = useRef();
    const tableRef = useRef();

    // 📋 साझा स्टेट्स (Shared States - One input controls both Chart and Table)
    const [inverters, setInverters] = useState([]);
    const [compareInverters, setCompareInverters] = useState([]);
    const [metric, setMetric] = useState("ENG");
    const [loading, setLoading] = useState(false);
    const [fromDate, setFromDate] = useState(getDateTimeForDashboardTab1().LastWeek);
    const [toDate, setToDate] = useState(getDateTimeForDashboardTab1().Today);

    // 📊 चार्ट और टेबल का साझा डेटा स्टेट
    const [chartData, setChartData] = useState(null);
    const [tableDates, setTableDates] = useState([]);
    const [tableRows, setTableRows] = useState({});

    // 🔑 क्रेडेंशियल्स
    const credentials = {
        LOGIN_ID: sessionStorage.getItem("LoginID") || localStorage.getItem("LoginID"),
        LOC_CODE: sessionStorage.getItem("LCODE") || localStorage.getItem("LCODE"),
        PASS_KEY: 'XYZ',
        WEB_KEY: "WEBXYZ321",
        TYP: "I",
    };

    // 🔹 इनवर्टर लिस्ट लोड करना
    const fetchInverters = async () => {
        try {
            const res = await axios.get(`${BaseUrl}CMN_07_Super/GET_FEEDER_LIST`, { params: credentials });
            setInverters(res.data.FEED || []);
            resetData();
        } catch (err) {
            console.error("Inverter API Error:", err);
        }
    };

    const resetData = () => {
        setChartData(null);
        setTableDates([]);
        setTableRows({});
    };

    // 🗹 चेकबॉक्स/टॉगल हैंडलर
    const toggleCompareInverter = (inv) => {
        setCompareInverters((prev) =>
            prev.some((c) => c.feeder_id === inv.feeder_id)
                ? prev.filter((c) => c.feeder_id !== inv.feeder_id)
                : [...prev, inv]
        );
    };

    // 🔄 कंबाइंड डेटा फ़ेचिंग फंक्शन (दोनों विज़ुअल्स को एक साथ फीड करता है)
    const fetchDashboardData = async (isMounted = { current: true }) => {
        if (compareInverters.length === 0) {
            resetData();
            return;
        }

        setLoading(true);
        try {
            let datasets = [];
            let sharedLabels = [];
            let allDates = new Set();
            let tempRows = {};

            // सभी चयनित इनवर्टर का डेटा समानांतर (Parallel) या क्रमिक रूप से लाना
            for (let i = 0; i < compareInverters.length; i++) {
                const inv = compareInverters[i];
                const res = await axios.get(`${BaseUrl}CMN_08InvLog/Get_Inv_Perf`, {
                    params: {
                        LOGIN_ID: credentials.LOGIN_ID,
                        LOC_CODE: credentials.LOC_CODE,
                        PASS_KEY: credentials.PASS_KEY,
                        WEB_KEY: credentials.WEB_KEY,
                        MTR_NO: inv.feeder_id,
                        DT1: fromDate,
                        DT2: toDate,
                    },
                });

                if (!isMounted.current) return; // अगर कंपोनेंट अनमाउंट हो गया है तो स्टेट अपडेट न करें

                const apiData = res.data.data || [];
                if (apiData.length === 0) continue;

                // तारीखों को व्यवस्थित करना
                const invLabels = apiData.map((d) => d.DATET || d.date || "");
                const values = apiData.map((d) => parseFloat(d[metric] ?? 0));

                if (i === 0) sharedLabels = invLabels;

                // रैंडम फिक्स कलर जनरेशन ताकि चार्ट रेंडरिंग के समय रंग बार-बार न बदले
                const hue = (i * 137.5) % 360;
                const borderColor = `hsl(${hue}, 70%, 50%)`;

                datasets.push({
                    label: `${inv.name}`,
                    data: values,
                    borderColor: borderColor,
                    backgroundColor: borderColor,
                    fill: false,
                    tension: 0.2,
                });

                // टेबल के लिए रो (Rows) मैपिंग
                apiData.forEach((d) => {
                    const dateKey = d.DATET || d.date || "N/A";
                    const value = parseFloat(d[metric] ?? 0);
                    allDates.add(dateKey);

                    if (!tempRows[dateKey]) {
                        tempRows[dateKey] = {};
                    }
                    tempRows[dateKey][inv.feeder_id] = isNaN(value) ? 0 : value;
                });
            }

            if (!isMounted.current) return;

            if (datasets.length === 0) {
                alert("selected inverters no data");
                resetData();
            } else {
                // तारीखों को क्रमानुसार सॉर्ट करना (ताकि टेबल व्यवस्थित दिखे)
                const sortedDates = Array.from(allDates).sort((a, b) => new Date(a) - new Date(b));

                setChartData({ labels: sharedLabels, datasets });
                setTableDates(sortedDates);
                setTableRows(tempRows);
            }
        } catch (err) {
            console.error("Dashboard Data Fetch Error:", err);
        } finally {
            if (isMounted.current) setLoading(false);
        }
    };

    // इनिशियल लोड
    useEffect(() => {
        fetchInverters();
    }, []);

    // इनवर्टर बदलने, मीट्रिक बदलने या तारीख बदलने पर स्वतः रिफ्रेश
    useEffect(() => {
        const isMounted = { current: true };
        fetchDashboardData(isMounted);

        return () => {
            isMounted.current = false;
        };
    }, [metric, compareInverters, fromDate, toDate]);

    // 📄 एक्सेल एक्सपोर्ट (Excel Export)
    const ImageUrl = `${BaseUrl}CMN_02/GET_COM_LOGO?LOGIN_ID=${credentials.LOGIN_ID}&LOC_CODE=${credentials.LOC_CODE}&PASS_KEY=${credentials.PASS_KEY}&WEB_KEY=${credentials.WEB_KEY}`;

    const exportToExcel = async () => {
        if (tableDates.length === 0) {
            alert("no data");
            return;
        }

        const exportData = tableDates.map((date) => {
            let row = { "Date": date };
            compareInverters.forEach((inv) => {
                const val = tableRows[date]?.[inv.feeder_id];
                row[`${inv.name} (${inv.kwp} kWp)`] = val !== undefined ? val.toFixed(2) : "-";
            });
            return row;
        });

        if (typeof ExportExcel === "function") {
            await ExportExcel(ImageUrl, exportData, fromDate, toDate, `General_Comparison`, LoggedInUserInfo);
        } else {
            console.error("ExportExcel ");
        }
    };

    return (
        <div style={{ padding: "10px", fontFamily: "sans-serif" }}>
            {/* 🏷️ मेन हेडर */}
            <div style={headerCardStyle}>
                <h5 style={{ margin: 0 }}> Analytics </h5>
            </div>

            {/* 🗂️ साझा इनवर्टर सिलेक्शन पैनल्स */}
            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginTop: 12 }}>
                <div style={panelStyle}>
                    <h6 style={{ margin: "0 0 8px 0" }}>Inverters</h6>
                    <ul style={listStyle}>
                        {inverters.map((inv) => (
                            <li key={inv.feeder_id} style={listItem}>
                                <input
                                    type="checkbox"
                                    checked={compareInverters.some((c) => c.feeder_id === inv.feeder_id)}
                                    onChange={() => toggleCompareInverter(inv)}
                                />
                                <span style={nameStyle}>{inv.name}</span>
                                <span style={capStyle}>[{inv.kwp}kWp]</span>
                            </li>
                        ))}
                    </ul>
                </div>

                <div style={panelStyle}>
                    <h6 style={{ margin: "0 0 8px 0" }}>Compare Inverters</h6>
                    <ul style={listStyle}>
                        {compareInverters.map((c) => (
                            <li key={c.feeder_id} style={listItem}>
                                <span style={nameStyle}>{c.name}</span>
                                <span style={capStyle}>{c.kwp}kWp</span>
                                <button style={removeBtn} onClick={() => toggleCompareInverter(c)}>Remove</button>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            {/* 🔍 कॉमन फ़िल्टर्स बार (Dropdown, Dates, Buttons) */}
            <div style={filterStyle}>
                <label style={labelStyle}>Select Type:</label>
                <select value={metric} onChange={(e) => setMetric(e.target.value)} style={selectStyle}>
                    <option value="ENG">Energy Generation</option>
                    <option value="CUF">CUF</option>
                    <option value="Specific_Yield">Specific Yield</option>
                    <option value="Specific_Power">Specific Power</option>
                    <option value="KW_MAX">Peak Generation</option>
                    <option value="PR">PR</option>
                </select>

                <label style={labelStyle}>From:</label>
                <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} style={inputStyle} />

                <label style={labelStyle}>To:</label>
                <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} style={inputStyle} />

                <TbRefresh
                    style={{ fontSize: "1.6rem", cursor: "pointer", color: "#007bff" }}
                    onClick={() => fetchDashboardData()}
                    title="Refresh Data"
                />

                <DownloadJpegButton targetRef={chartRef} fileName={`General Comparison Chart.jpeg`} />
                <button style={excelBtnStyle} onClick={exportToExcel}>Export to Excel</button>
            </div>

            {/* 📉 चार्ट व्यू */}
            {chartData && !loading && (
                <div style={chartContainerStyle} ref={chartRef}>
                    <h6 style={{ margin: "0 0 10px 0" }}>Analytics (Chart View)</h6>
                    <div style={{ height: 260, width: "100%" }}>
                        <Line
                            data={chartData}
                            options={{
                                responsive: true,
                                maintainAspectRatio: false,
                                plugins: {
                                    legend: { position: "top", labels: { font: { size: 12 } } },
                                },
                                scales: {
                                    x: { ticks: { font: { size: 11 } } },
                                    y: { ticks: { font: { size: 11 } } },
                                },
                            }}
                        />
                    </div>
                </div>
            )}

            {/* 📊 टेबुलर व्यू */}
            <div style={{ marginTop: 20 }} ref={tableRef}>
                <div style={headerCardStyle}>
                    <h5 style={{ margin: 0 }}>Analytics (Tabular View)</h5>
                </div>

                {loading ? (
                    <div style={{ textAlign: "center", padding: "30px", fontWeight: "bold" }}>Loading  Data...</div>
                ) : tableDates.length > 0 ? (
                    <div style={tableResponsiveContainer}>
                        <table style={tableStyleStructure}>
                            <thead>
                                <tr style={{ backgroundColor: "#007bff", color: "white" }}>
                                    <th style={thTdStyle}>Date</th>
                                    {compareInverters.map((inv) => (
                                        <th key={inv.feeder_id} style={thTdStyle}>
                                            {inv.name} <br />
                                            <span style={{ fontSize: "0.75rem", fontWeight: "normal" }}>({inv.kwp} kWp)</span>
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {tableDates.map((date) => (
                                    <tr key={date} style={{ borderBottom: "1px solid #ddd" }}>
                                        <td style={{ ...thTdStyle, fontWeight: "bold" }}>{date}</td>
                                        {compareInverters.map((inv) => {
                                            const val = tableRows[date]?.[inv.feeder_id];
                                            return (
                                                <td key={inv.feeder_id} style={thTdStyle}>
                                                    {val !== undefined ? val.toFixed(2) : "-"}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div style={noDataStyle}>
                        No data available. Please select inverters above to view Chart and Table analysis.
                    </div>
                )}
            </div>
        </div>
    );
}

/* ---------- 🎨 सीएसएस इनलाइन स्टाइल्स ---------- */
const headerCardStyle = { borderTop: "1px solid #ccc", borderRadius: "6px", padding: "8px", backgroundColor: "white", boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)" };
const panelStyle = { flex: 1, minWidth: 220, border: "1px solid #ccc", borderRadius: 6, padding: 10, maxHeight: 170, overflowY: "auto", backgroundColor: "white", boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)" };
const listStyle = { listStyle: "none", padding: 0, margin: 0 };
const listItem = { display: "flex", alignItems: "center", gap: 6, marginBottom: 6 };
const nameStyle = { fontSize: 13, fontWeight: "500" };
const capStyle = { color: "#888", fontSize: 12 };
const removeBtn = { marginLeft: "auto", background: "#ff5252", color: "white", border: "none", padding: "2px 6px", borderRadius: 4, cursor: "pointer", fontSize: 11 };
const filterStyle = { marginTop: 15, display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap", backgroundColor: "#f9f9f9", padding: 10, borderRadius: 6, boxShadow: "0 2px 6px rgba(0,0,0,0.12)" };
const labelStyle = { fontSize: 14, fontWeight: 500 };
const inputStyle = { fontSize: 14, borderRadius: 6, border: "1px solid #ccc", padding: "4px 10px", height: 32 };
const selectStyle = { fontSize: 14, borderRadius: 6, border: "1px solid #ccc", padding: "4px 10px", height: 32, backgroundColor: "white" };
const excelBtnStyle = { padding: "6px 12px", backgroundColor: "#28a745", color: "white", border: "none", borderRadius: "4px", fontWeight: "bold", cursor: "pointer", fontSize: 13 };
const chartContainerStyle = { marginTop: 15, backgroundColor: "white", borderRadius: 8, padding: 12, boxShadow: "0 4px 10px rgba(0,0,0,0.15)" };
const tableResponsiveContainer = { overflowX: "auto", boxShadow: "0 4px 10px rgba(0,0,0,0.15)", borderRadius: "8px", backgroundColor: "white", marginTop: 10 };
const tableStyleStructure = { width: "100%", borderCollapse: "collapse", textAlign: "left" };
const thTdStyle = { padding: "10px 12px", border: "1px solid #ddd", fontSize: "13px" };
const noDataStyle = { textAlign: "center", padding: "20px", backgroundColor: "#fff", border: "1px solid #ddd", borderRadius: "8px", color: "#666", marginTop: 10 };

export default UserAnalyticsTab1;